/* Coverax – Rechtliche Seiten: räumt Admin-Inhalte auf und verlinkt Inhaltsverzeichnisse. */
(() => {
  // Mobile Pill-Navigation: aktuelle Seite in den sichtbaren Bereich scrollen
  const navList = document.querySelector('.cx-policy__nav-list');
  const current = navList && navList.querySelector('.is-current');
  if (current && navList.scrollWidth > navList.clientWidth) {
    navList.scrollLeft = current.offsetLeft - (navList.clientWidth - current.offsetWidth) / 2;
  }

  const body = document.querySelector('.cx-policy .shopify-policy__body .rte');
  if (!body) return;

  // Leerabsätze aus dem Admin-Editor (&nbsp;, <br>) entfernen
  body.querySelectorAll('p').forEach((p) => {
    if (p.querySelector('img, iframe, video')) return;
    if (p.textContent.replace(/ /g, ' ').trim() === '') p.remove();
  });

  const slugify = (text) =>
    text
      .toLowerCase()
      .replace(/ä/g, 'ae')
      .replace(/ö/g, 'oe')
      .replace(/ü/g, 'ue')
      .replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

  // Ohne führende Nummerierung wie "1)", "1.", "§ 1"
  const normalize = (text) =>
    text
      .replace(/ /g, ' ')
      .replace(/^\s*(§\s*)?\d+[.)]?\s*/, '')
      .trim()
      .toLowerCase();

  const headings = Array.from(body.querySelectorAll('h2, h3'));
  const used = new Set();
  headings.forEach((heading) => {
    if (heading.id) return;
    let id = slugify(heading.textContent) || 'abschnitt';
    while (used.has(id) || document.getElementById(id)) id += '-2';
    used.add(id);
    heading.id = id;
  });

  // Liste direkt nach einer Überschrift "Inhaltsverzeichnis" mit den Abschnitten verknüpfen
  const tocHeading = headings.find((h) => /^inhalts(verzeichnis|übersicht)$/i.test(h.textContent.trim()));
  const tocList = tocHeading && tocHeading.nextElementSibling;
  if (!tocList || !/^(OL|UL)$/.test(tocList.tagName)) return;

  tocList.classList.add('cx-policy__toc');
  const targets = headings.filter((h) => h !== tocHeading);
  tocList.querySelectorAll(':scope > li').forEach((li) => {
    if (li.querySelector('a')) return;
    const label = normalize(li.textContent);
    const target = targets.find((h) => normalize(h.textContent) === label);
    if (!target) return;
    const link = document.createElement('a');
    link.href = `#${target.id}`;
    link.textContent = li.textContent.trim();
    li.replaceChildren(link);
  });
})();
